/* This file is generated by createIcons.js any changes will be lost. */
import createIcon from '../createIcon';
export const ExpandArrowsAltIconConfig = {
  name: 'ExpandArrowsAltIcon',
  height: 512,
  width: 448,
  svgPath: 'M448 344v112a23.94 23.94 0 0 1-24 24H312c-21.39 0-32.09-25.9-17-41l36.2-36.2L224 295.6 116.77 402.9 153 439c15.09 15.1 4.39 41-17 41H24a23.94 23.94 0 0 1-24-24V344c0-21.4 25.89-32.1 41-17l36.19 36.2L184.46 256 77.18 148.7 41 185c-15.1 15.1-41 4.4-41-17V56a23.94 23.94 0 0 1 24-24h112c21.39 0 32.09 25.9 17 41l-36.2 36.2L224 216.4l107.23-107.3L295 73c-15.09-15.1-4.39-41 17-41h112a23.94 23.94 0 0 1 24 24v112c0 21.4-25.89 32.1-41 17l-36.19-36.2L263.54 256l107.28 107.3L407 327.1c15.1-15.2 41-4.5 41 16.9z',
  yOffset: '',
  xOffset: '',
  transform: ''
};
export default createIcon(ExpandArrowsAltIconConfig);
//# sourceMappingURL=expand-arrows-alt-icon.js.map